import React, { useMemo } from 'react';
import { useFormContext, useController, get } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { v4 } from 'uuid';
import { Field, ChipInput as ChipInput$1 } from '@panwds/react-ui';
import { requiredMessage } from '../../messages.esm.js';

/**
 * Renders a chip input connected to the form. All extra props will get passed to the base chip input.
 */
const ChipInput = (props) => {
    var _a;
    const { name, label, register = {}, defaultValue = [], description, tooltip, disabled, showLabel, ...rest } = props;
    const labelId = useMemo(() => `field-${v4()}-label`, []);
    const inputId = useMemo(() => `field-${v4()}-input`, []);
    const context = useFormContext();
    const intl = useIntl();
    /* istanbul ignore next */
    if (process.env.NODE_ENV === "development" && context === null) {
        throw new Error("Attempted to render ChipInput outside of a Form context. Make sure your component is rendered inside <Form>.");
    }
    const { formState } = context;
    register.required =
        register.required === false
            ? register.required
            : intl.formatMessage(requiredMessage, {
                label,
            });
    const { field: { onBlur, onChange, value }, } = useController({
        name,
        defaultValue,
        rules: register,
    });
    const selectedItemChange = ({ selectedItems }) => {
        onChange(selectedItems);
    };
    return (React.createElement(Field, { connectLabel: false, label: label, labelId: labelId, optional: !register.required, control: React.createElement(ChipInput$1, { ...rest, disabled: disabled, labelId: labelId, inputId: inputId, selectedItems: value, onInputBlur: onBlur, onSelectedItemsChange: selectedItemChange }), error: (_a = get(formState.errors, name)) === null || _a === void 0 ? void 0 : _a.message, description: description, tooltip: tooltip, disabled: disabled, showLabel: showLabel }));
};

export { ChipInput };
//# sourceMappingURL=ChipInput.esm.js.map
